module.exports = __webpack_public_path__ + "assets/img/sea_food.1f1b11d5.png";